import './bootstrap/installGlobalErrorHandlers';
// Must run before the first render: the initial organization is selected as soon
// as the user-data fetch resolves, and nothing may observe a switch it missed.
import './bootstrap/installOrgScope';
import { createRoot } from 'react-dom/client';
import { CookiesProvider } from 'react-cookie';
import { App } from './App';
import './styles/globals.css';
import { ErrorBoundary } from './components/organisms/ErrorBoundary';
import { loader } from '@monaco-editor/react';

// Configure Monaco Editor
loader.config({
  paths: {
    vs: '/vs'
  }
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <ErrorBoundary>
    <CookiesProvider>
      <App />
    </CookiesProvider>
  </ErrorBoundary>
);